/* eslint-disable no-param-reassign */
import angular from 'angular';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import flattenDeep from 'lodash/flattenDeep';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import forEachRight from 'lodash/forEachRight';
import isUndefined from 'lodash/isUndefined';

class SashesService {
    constructor(config, dividersService, windowDimensionsService, internalSashesService,
        mullionsService, fixedSashesService, jsonBuilderService, $injector, $rootScope) {
        this.config = config;
        this.dividersService = dividersService;
        this.windowDimensionsService = windowDimensionsService;
        this.internalSashesService = internalSashesService;
        this.mullionsService = mullionsService;
        this.fixedSashesService = fixedSashesService;
        this.jsonBuilderService = jsonBuilderService;
        this.$injector = $injector;
        this.$rootScope = $rootScope;
        this.fixedSashesGroups = [];
        this.initialSashData = [];
        this.sashes = [];
        this.dividersHor = 0;
        this.dividersVert = 0;
        this.mullionsHor = 0;
        this.mullionsVert = 0;
        this.standardFields = 0;
        this.topLightFields = 0;
    }

    addBottomPannel() {
        forEach(this.getNonFixedSashes(), (el) => {
            if (el.type.type === 'OD' || el.type.type === 'D' || el.type.type === 'DK') {
                if (!find(el.intDividers, el1 => el1.dividerId === this.config.jsonConfig.bottomPannelDividerId)) {
                    const currentSash = el;
                    const divider = this.dividersService.createDividerAboveBottomPannel(currentSash);
                    const bottomPannel = this.internalSashesService.createBottomPannelIntSash(currentSash);

                    bottomPannel.nearDividers.top = divider.id;
                    divider.adjacentSashes.bottom.push(bottomPannel.id);

                    this.dividersService.addAdjacentDividersToBottomDivider(divider, currentSash);
                    this.dividersService.addAdjacentSashesToBottomDivider(divider, currentSash);

                    currentSash.intDividers.push(cloneDeep(divider));
                    currentSash.intSashes.push(cloneDeep(bottomPannel));
                }
            }
        });

        this.windowDimensionsService.setBottomPannelCreateFlag(true);
    }

    addMullion(sash, direction) {
        if (sash.intSashes.length < 1) {
            this.mullionsService.addMullionToSash(direction, sash);
        } else {
            this.mullionsService.addMulionToIntSashes(direction, sash);
        }
    }

    addMullions(direction) {
        forEach(this.sashes, (el) => {
            this.addMullion(el, direction);
        });
    }

    addNewSashes(sashes) {
        this.fixedSashesGroups.push(sashes);
        forEach(sashes, (el) => {
            this.sashes.push(el);
        });
    }

    addSashDivider(direction) {
        this.removeOldFixSashes();
        this.dividersService.resetDividers();

        forEach(this.getInitialFixedSashes(), (el) => {
            const allSashes = flattenDeep([this.getSashesJson(), this.getInitialFixedSashes()]);
            const newSash = this.fixedSashesService.splitSash(cloneDeep(el), allSashes);
            this.addNewSashes(newSash);
        });
        forEach(this.getNonFixedSashes(), (el) => {
            const newDividerId = this.dividersService.getNewDividerId(this.getSashesJson());

            if (direction === 'vertical') {
                this.dividersService.addVerticalIntDivider(el, newDividerId);
            } else {
                this.dividersService.addHorizontalIntDivider(el, newDividerId);
            }
        });
    }

    get dividersHor() {
        return this.windowDimensionsService.getHorizontalDividersLength();
    }

    get dividersVert() {
        return this.windowDimensionsService.getVerticalDividersLength();
    }

    get mullionsHor() {
        return this.windowDimensionsService.getMullionsHor();
    }

    get mullionsVert() {
        return this.windowDimensionsService.getMullionsVert();
    }

    getFixedSashes() {
        return filter(this.sashes, el => el.type.id === this.config.sashTypes.F);
    }

    getNonFixedSashes() {
        return filter(this.sashes, el => el.type.id !== this.config.sashTypes.F);
    }

    getInitialFixedSashes() {
        return filter(this.getInitialSashes(), el => el.type.id === this.config.sashTypes.F);
    }

    getInitialSashes() {
        return this.initialSashData;
    }

    getSashDividers(direction) {
        const allDividers = this.sashes[this.sashes.length - 1].intDividers;

        return filter(allDividers, ['direction', direction]);
    }

    getSashesJson() {
        return this.sashes;
    }

    getSashesArea() {
        let sashArea = 0;

        forEach(this.sashes, (el) => {
            sashArea += (el.height / 1000) * (el.width / 1000);
        });

        return sashArea;
    }

    initWindowDimensions() {
        this.windowDimensionsService.setSashesJson(this.getSashesJson());
    }

    removeBottomPannel() {
        forEach(this.sashes, (el) => {
            const rmv = el.intDividers.splice(-1, 1);

            if (rmv.length > 0) {
                forEach(el.intSashes, (el1) => {
                    if (el1.nearDividers.bottom === rmv[0].id) {
                        el1.nearDividers.bottom = -1;
                    }
                });
                el.intSashes.splice(-1, 1);
            }
        });

        this.windowDimensionsService.setBottomPannelCreateFlag(false);
    }

    removeOldFixSashes() {
        this.fixedSashesGroups = [];
        forEach(this.getFixedSashes(), (el) => {
            this.sashes.splice(this.sashes.indexOf(el), 1);
        });
    }

    resetAdjacentSashes() {
        forEach(this.dividersService.getDividersJson(), (el) => {
            const currentDivider = el;

            if (currentDivider.direction === 'vertical') {
                currentDivider.adjacentSashes = {
                    left: [],
                    right: []
                };
            } else {
                currentDivider.adjacentSashes = {
                    top: [],
                    bottom: []
                };
            }
        });
    }

    resetMullions() {
        this.mullionsService.resetMullionLength();
        const defaultValue = this.config.jsonConfig.muntins;

        forEach(this.sashes, (el) => {
            const currentSash = el;

            currentSash.muntins = cloneDeep(defaultValue);

            if (currentSash.intSashes.length) {
                forEach(currentSash.intSashes, (el1) => {
                    const currentInternalSash = el1;

                    currentInternalSash.muntins = cloneDeep(defaultValue);
                });
            }
        });
    }

    resetSashes() {
        this.sashes = cloneDeep(this.initialSashData);

        // we have to take under consideration that we have to check current selected side of hangings
        // otherwise we will end up with wrong side and drawing because intial sash can be right but customer already changed tht to left
        // this is why we need to "recalculate" hingeSide and activeSash (other options seems to work properly)
        // in future
        const hingeSide = this.$injector.get('dataService').data.data[0].relationships.hingeSide;
        const activeSash = (this.$injector.get('dataService').data.data[0].relationships.activeSash && (this.$injector.get('dataService').data.data[0].attributes.windowFunctionId === 2))

        if (hingeSide) {
            const selectedHingeSideId = this.$injector.get('dataService').data.data[0].relationships.hingeSide.data.id;
            const defaultInsideView = this.$injector.get('dataService').data.data[0].attributes.defaultInsideView;
            this.updateHingeSide(selectedHingeSideId, defaultInsideView);
        }
        if (activeSash) {
            const selectedActiveSashId = this.$injector.get('dataService').data.data[0].relationships.activeSash.data.id;
            this.updateActiveSash(selectedActiveSashId);
        }
    }

    set dividersHor(value) {
        const newValue = String(value).replace(/\D/g, '');

        if (angular.isDefined(value) && value && value >= 0) {
            value = parseInt(newValue, 10);
            this.windowDimensionsService.setHorizontalDividersLength(value);
        } else {
            this.windowDimensionsService.setHorizontalDividersLength(0);
        }
    }

    set dividersVert(value) {
        const newValue = String(value).replace(/\D/g, '');

        if (angular.isDefined(value) && value && value >= 0) {
            value = parseInt(newValue, 10);
            this.windowDimensionsService.setVerticalDividersLength(value);
        } else {
            this.windowDimensionsService.setVerticalDividersLength(0);
        }
    }

    set mullionsHor(value) {
        const newValue = String(value).replace(/\D/g, '');

        if (angular.isDefined(value) && value && value >= 0) {
            value = parseInt(newValue, 10);
            this.windowDimensionsService.setMullionsHor(value);
        } else {
            this.windowDimensionsService.setMullionsHor(0);
        }
    }

    set mullionsVert(value) {
        const newValue = String(value).replace(/\D/g, '');

        if (angular.isDefined(value) && value && value >= 0) {
            value = parseInt(newValue, 10);
            this.windowDimensionsService.setMullionsVert(value);
        } else {
            this.windowDimensionsService.setMullionsVert(0);
        }
    }

    setInitialData(jsonObject, currentGlazing) {
        this.jsonObject = jsonObject;
        this.validateSashesJson(jsonObject);
        this.validateDividers(jsonObject);
        this.windowDimensionsService.setInitialData(jsonObject);
        this.dividersService.setInitialData(jsonObject);
        this.setSash(jsonObject);
        this.initWindowDimensions();
        this.updateSashDisplacement();
        forEach(this.getFixedSashes(), (el) => {
            this.fixedSashesGroups.push([el]);
        });
        this.setInitialDividersAndSashes(currentGlazing);
        this.updateSashesDimensions();
    }

    setInitialDividersAndSashes(currentGlazing) {
        this.resetMullions();
        this.resetSashes();

        let verticalDividers = this.windowDimensionsService.getVerticalDividersLength();
        let horizontalDividers = this.windowDimensionsService.getHorizontalDividersLength();
        if (currentGlazing) {
            verticalDividers = currentGlazing.data.verticalDividers;
            horizontalDividers = currentGlazing.data.horizontalDividers;
        }
        const verticalMullions = this.windowDimensionsService.getMullionsVert();
        const horizontalMullions = this.windowDimensionsService.getMullionsHor();

        for (let i = 0; i < verticalDividers; i++) {
            this.addSashDivider('vertical');
        }
        for (let i = 0; i < horizontalDividers; i++) {
            this.addSashDivider('horizontal');
        }
        for (let i = 0; i < verticalMullions; i++) {
            this.addMullions('vertical');
        }
        for (let i = 0; i < horizontalMullions; i++) {
            this.addMullions('horizontal');
        }
    }

    setIntSashDimensions(currentIntSash, index, sash, sashId) {
        const intSash = currentIntSash;
        let x;
        let y;

        intSash.width = this.windowDimensionsService.getIntSashWidth(sash);
        intSash.height = this.windowDimensionsService.getSashHeight(
            sashId,
            this.windowDimensionsService.isBottomPannel()
        ) / (this.windowDimensionsService.getHorizontalDividersLength() + 1);

        if (this.windowDimensionsService.isSplitHorDiv) {
            x = index % this.windowDimensionsService.multiplierHor;
            y = Math.floor(index / this.windowDimensionsService.multiplierHor);
        } else {
            y = index % this.windowDimensionsService.multiplierVert;
            x = Math.floor(index / this.windowDimensionsService.multiplierVert);
        }
        intSash.x = x * intSash.width;
        intSash.y = y * intSash.height;
    }

    setNewApiIdInInternalDividers(apiId) {
        forEach(this.getNonFixedSashes(), (el) => {
            forEach(el.intDividers, (el1) => {
                const currentIntDividers = el1;
                currentIntDividers.dividerId = apiId;
            });
        });
    }

    setSash(jsonObject) {
        this.sashes = jsonObject.sashes;
        this.initialSashData = cloneDeep(jsonObject.sashes);
    }

    setSashDimensions(currentSash, index) {
        const sash = currentSash;

        sash.width = this.windowDimensionsService.getSashWidth(currentSash.id);
        sash.height = this.windowDimensionsService.getSashHeight(index);

        this.checkSashFunction(sash, index);
    }

    checkSashFunction(sash, index) {
        const currentSash = sash;
        const dataServiceDataObject = this.$injector.get('dataService').data.data[0];

        // casement window
        if (sash.type.type.toUpperCase() === 'DK' &&
            sash.height <= sash.width * 0.8 &&
            currentSash.type.type !== 'K' &&
            dataServiceDataObject.attributes.standardFields === 1
        ) {
            currentSash.type.previousType = currentSash.type.type;
            currentSash.type.previousHandlePosition = currentSash.type.handlePosition;
            currentSash.type.type = 'K';
            currentSash.type.handlePosition = 'T';

            if (isUndefined(dataServiceDataObject.attributes.previousWindowFunctionId)) {
                dataServiceDataObject.attributes.previousWindowFunctionId = dataServiceDataObject.attributes.windowFunctionId;
            }
            dataServiceDataObject.attributes.windowFunctionId = 11;

            if (dataServiceDataObject.relationships.hingeSide) {
                dataServiceDataObject.relationships.hingeSide.data.previousId = dataServiceDataObject.relationships.hingeSide.data.id;
                dataServiceDataObject.relationships.hingeSide.data.id = 3;
            }
            this.$rootScope.$emit('showCasementModalEvent');
        } else if (sash.type.type === 'K' && sash.height > sash.width * 0.8 && currentSash.type.previousType) {
            currentSash.type.type = currentSash.type.previousType;
            currentSash.type.handlePosition = currentSash.type.previousHandlePosition;

            if (dataServiceDataObject.attributes.previousWindowFunctionId) {
                dataServiceDataObject.attributes.windowFunctionId = dataServiceDataObject.attributes.previousWindowFunctionId;
            }
            if (dataServiceDataObject.relationships.hingeSide && dataServiceDataObject.relationships.hingeSide.data.previousId) {
                dataServiceDataObject.relationships.hingeSide.data.id = dataServiceDataObject.relationships.hingeSide.data.previousId;
            }
        }
        if ((index === 0 && currentSash.type.type.toUpperCase() === 'K' && this.sashes.length === 1) ||
            (index === 1 && currentSash.type.type.toUpperCase() === 'K' && this.sashes.length === 3)) {
            this.windowDimensionsService.hideHingeSide = true;
        }
        if (currentSash.type.type.toUpperCase() === 'K') {
            this.windowDimensionsService.showWindowTiltHingeSide = true;
        }
        this.$rootScope.$emit('windowFunctionChangeEvent');
    }

    switchFixOption(option) {
        forEach(this.sashes, (el) => {
            if (el.type.id === this.config.sashTypes.F || el.type.id === this.config.sashTypes.FF) {
                const currentSash = el;
                currentSash.type.id = parseInt(option, 10);
            }
        });
    }

    setData(data) {
        this.apiData = data;
    }

    updateActiveSash(value) {
        switch (parseInt(value, 10)) {
            case 1:
                this.sashes[0].type.id = this.config.sashTypes.DS.R;
                this.sashes[0].type.handlePosition = 'R';
                this.sashes[0].type.type = 'DS';
                this.sashes[1].type.id = this.config.sashTypes.DK.L;
                this.sashes[1].type.handlePosition = 'L';
                this.sashes[1].type.type = 'DK';
                break;
            case 2:
                this.sashes[0].type.id = this.config.sashTypes.DK.R;
                this.sashes[0].type.handlePosition = 'R';
                this.sashes[0].type.type = 'DK';
                this.sashes[1].type.id = this.config.sashTypes.DS.L;
                this.sashes[1].type.handlePosition = 'L';
                this.sashes[1].type.type = 'DS';
                break;
            case 3:
                this.sashes[0].type.id = this.config.sashTypes.DK.R;
                this.sashes[0].type.handlePosition = 'R';
                this.sashes[0].type.type = 'DK';
                this.sashes[1].type.id = this.config.sashTypes.DK.L;
                this.sashes[1].type.handlePosition = 'L';
                this.sashes[1].type.type = 'DK';
                break;
            default:
                throw new Error('Value doesn\'t match');
        }
    }

    updateAdjacentDividers() {
        forEach(this.sashes, (el) => {
            const currentSash = el;
            let divider;

            if (currentSash.nearDividers.bottom !== -1 && currentSash.nearDividers.right !== -1) {
                divider = this.dividersService.getDivider(currentSash.nearDividers.bottom);
                if (divider.adjacentDividers.top.indexOf(currentSash.nearDividers.right) < 0) {
                    divider.adjacentDividers.top.push(currentSash.nearDividers.right);
                }
            }
            if (currentSash.nearDividers.top !== -1 && currentSash.nearDividers.right !== -1) {
                divider = this.dividersService.getDivider(currentSash.nearDividers.top);
                if (divider.adjacentDividers.bottom.indexOf(currentSash.nearDividers.right) < 0) {
                    divider.adjacentDividers.bottom.push(currentSash.nearDividers.right);
                }
            }
            if (currentSash.nearDividers.bottom !== -1 && currentSash.nearDividers.right !== -1) {
                divider = this.dividersService.getDivider(currentSash.nearDividers.right);
                if (divider.adjacentDividers.left.indexOf(currentSash.nearDividers.bottom) < 0) {
                    divider.adjacentDividers.left.push(currentSash.nearDividers.bottom);
                }
            }
            if (currentSash.nearDividers.bottom !== -1 && currentSash.nearDividers.left !== -1) {
                divider = this.dividersService.getDivider(currentSash.nearDividers.left);
                if (divider.adjacentDividers.right.indexOf(currentSash.nearDividers.bottom) < 0) {
                    divider.adjacentDividers.right.push(currentSash.nearDividers.bottom);
                }
            }
        });
    }

    updateAdjacentSash() {
        const divServ = this.dividersService;
        this.resetAdjacentSashes();

        forEach(this.sashes, (el) => {
            const nearDividers = el.nearDividers;
            let divider;

            if (nearDividers.top !== -1) {
                divider = this.dividersService.getDivider(nearDividers.top);
                divServ.addAdjacentSash(divider, el.id, 'bottom');
            }

            if (nearDividers.bottom !== -1) {
                divider = this.dividersService.getDivider(nearDividers.bottom);
                divServ.addAdjacentSash(divider, el.id, 'top');
            }

            if (nearDividers.left !== -1) {
                divider = this.dividersService.getDivider(nearDividers.left);
                divServ.addAdjacentSash(divider, el.id, 'right');
            }

            if (nearDividers.right !== -1) {
                divider = this.dividersService.getDivider(nearDividers.right);
                divServ.addAdjacentSash(divider, el.id, 'left');
            }
        });
    }

    updateFixedSashes() {
        this.fixedSashesWeights = [];
        this.fixedSashesHeights = [];
        this.sashes.sort((a, b) => a - b);

        forEach(this.fixedSashesGroups, (el) => {
            forEach(el, (el1) => {
                const findId = el1.id % this.initialSashData.length;
                const sash = find(this.getFixedSashes(), el2 => el2.id === findId);
                if (angular.isDefined(sash) && el1.id < this.initialSashData.length) {
                    this.fixedSashesWeights.push(this.windowDimensionsService.getSashWidth(findId));
                    this.fixedSashesHeights.push(
                        this.windowDimensionsService.getSashHeight(
                            findId,
                            false
                        )
                    );
                }
            });
        });
        forEach(this.fixedSashesGroups, (el, index) => {
            if (el.length) {
                var width = angular.isDefined(this.fixedSashesWeights[index]) ? this.fixedSashesWeights[index] : this.fixedSashesHeights[0];
                var height = angular.isDefined(this.fixedSashesHeights[index]) ? this.fixedSashesHeights[index] : this.fixedSashesHeights[0];
                this.fixedSashesService.updateGroupDimensions(
                    el,
                    width,
                    height
                );
            }
        });
        forEach(this.fixedSashesGroups, (el) => {
            forEach(el, (el1) => {
                const sash = find(this.getFixedSashes(), el2 => el2.id === el1.id);
                if (angular.isDefined(sash)) {
                    sash.width = el1.width;
                    sash.height = el1.height;
                }
            });
        });
        this.updateFixedMuntins();
        this.sashes.sort((a, b) => b - a);
    }

    updateFixedMuntins() {
        forEach(this.getFixedSashes(), (el) => {
            const sash = find(this.getFixedSashes(), el1 => el1.id === el.id);
            const sashIndex = this.sashes.indexOf(sash);
            if (el.width && el.height) {
                this.mullionsService.updateMuntinsDimensions(el, sashIndex);
            }
        });
    }

    addFixedBottomPannel(bottomPanelDivider, topWindow) {
        const orgWindow = find(this.sashes, el => el.id === topWindow.id);
        const left = cloneDeep(orgWindow.nearDividers.left);
        const right = cloneDeep(orgWindow.nearDividers.right);
        let max = 0;

        forEach(this.jsonObject.sashes, (el) => {
            if (el.id > max) {
                max = el.id;
            }
        });

        return Object.assign(this.config.jsonConfig.defaultSash, {
            id: ++max,
            filling: this.config.jsonConfig.bottomPannelFilling,
            height: this.windowDimensionsService.height - this.windowDimensionsService.getBottomPannel(),
            nearDividers: {
                bottom: -1,
                left,
                right,
                top: bottomPanelDivider.id
            },
            width: bottomPanelDivider.length,
            type: { id: 1, handlePosition: null, type: 'F' },
            x: cloneDeep(orgWindow.x),
            y: this.windowDimensionsService.getBottomPannel(),
        });
    }

    removeBottomDividers() {
        const indexes = [];
        const windowIndexes = [];

        forEach(this.jsonObject.dividers, (el, index) => {
            if (el.dividerId === this.config.jsonConfig.bottomPannelDividerId) {
                indexes.push(index);
            }
        });

        forEach(this.jsonObject.sashes, (el, index) => {
            if (el.filling.id === this.config.jsonConfig.bottomPannelFilling.id) {
                windowIndexes.push(index);
            }
        });

        forEach(indexes, (el) => {
            forEach(this.jsonObject.dividers, (el1) => {
                if (el1.adjacentDividers.left && el1.adjacentDividers.left.indexOf(el) >= 0) {
                    el1.adjacentDividers.left.splice(el1.adjacentDividers.left.indexOf(el));
                }

                if (el1.adjacentDividers.right && el1.adjacentDividers.right.indexOf(el) >= 0) {
                    el1.adjacentDividers.right.splice(el1.adjacentDividers.right.indexOf(el));
                }
            });

            forEach(this.fixedSashesGroups, (el1) => {
                forEach(el1, (el2) => {
                    if (el2.nearDividers.bottom === el) {
                        el2.nearDividers.bottom = -1;
                    }
                });
            });
        });

        forEachRight(indexes, (el) => {
            this.jsonObject.dividers.splice(el, 1);
        });

        forEachRight(windowIndexes, (el) => {
            this.sashes.splice(el, 1);
        });
    }

    updateHandles(newHandle, side) {
        const handleKey = side === 'inside' ? 'handleInner' : 'handleOuter';
        forEach(this.sashes, (el) => {
            const currentSash = el;

            if (!isEmpty(currentSash[handleKey])) {
                currentSash[handleKey] = newHandle;
            }
        });
    }

    updateHingeSide(value, defaultInsideView) {
        const properValue = Number(value);
        const defaultSide = defaultInsideView ? 'inner' : 'outer';
        let handlePosition;

        if (properValue === 1) {
            handlePosition = defaultSide === 'inner' ? 'L' : 'R';
        } else if (properValue === 2) {
            handlePosition = defaultSide === 'inner' ? 'R' : 'L';
        } else if (properValue === 3) {
            handlePosition = 'T';
        }
        if (this.sashes.length === 1) {
            if (['D', 'OD', 'DK', 'K', 'SWH'].indexOf(this.sashes[0].type.type) > -1 && handlePosition !== 'T') {
                this.sashes[0].type.handlePosition = handlePosition;
            }
            if (['K'].indexOf(this.sashes[0].type.type) > -1 && handlePosition === 'T') {
                this.sashes[0].type.handlePosition = handlePosition;
            }
        } else if (this.sashes.length === 3) {
            this.sashes[1].type.handlePosition = handlePosition;
        }
    }

    updateNonFixedSashes() {
        forEach(this.getNonFixedSashes(), (el, index1) => {
            const nonFixed = filter(this.initialSashData, el1 => el1.type.id !== this.config.sashTypes.F);
            const nonFixedIndex = [];
            forEach(nonFixed, (el1) => {
                nonFixedIndex.push(this.initialSashData.indexOf(el1));
            });

            this.setSashDimensions(el, nonFixedIndex[index1]);
            this.dividersService.updateAdjacentDividers(el);

            forEach(el.intDividers, (el1, index) => {
                if (el1.dividerId !== this.config.jsonConfig.bottomPannelDividerId) {
                    this.dividersService.setDimension(el1, index, el, nonFixedIndex[index1]);
                }
            });

            forEach(el.intSashes, (el1, index) => {
                if (el1.filling.id !== this.config.jsonConfig.bottomPannelFilling.id) {
                    this.setIntSashDimensions(el1, index, el, nonFixedIndex[index1]);
                    this.mullionsService.updateMuntinsDimensions(el1, nonFixedIndex[index1]);
                }
            });
        });
    }

    updateSashesDimensions() {
        this.windowDimensionsService.showWindowTiltHingeSide = false;
        this.updateNonFixedSashes();
        this.updateAdjacentSash();
        this.updateSashDisplacement();

        if (this.getFixedSashes().length) {
            this.updateFixedSashes();
        }
        this.dividersService.updateWindowDividersDimensions(this.sashes);
        this.updateAdjacentDividers();
        this.updateGlazingBar();
        this.offsetMuntins();

        if (this.windowDimensionsService.isBottomPannel()) {
            this.addBottomPannel();
            // this.addBottomPannelToFixed();
        }
    }

    addBottomPannelToFixed() {
        forEach(this.fixedSashesGroups, (el, index) => {
            const bottomPanelDivider = this.dividersService.createDividerAboveBottomPannel({
                width: this.fixedSashesWeights[index]
            });
            forEach(el, (el1) => {
                if (el1.nearDividers.bottom === -1) {
                    el1.nearDividers.bottom = bottomPanelDivider.id;
                    bottomPanelDivider.adjacentSashes.top.push(el1.id);
                }
            });
            const firstDiv = el[0].nearDividers.left;
            const lastDiv = el[el.length - 1].nearDividers.right;
            if (firstDiv !== -1) {
                const divider = find(this.jsonObject.dividers, el1 => el1.id === firstDiv);
                divider.adjacentDividers.right.push(bottomPanelDivider.id);
            }
            if (lastDiv !== -1) {
                const divider = find(this.jsonObject.dividers, el1 => el1.id === lastDiv);
                divider.adjacentDividers.left.push(bottomPanelDivider.id);
            }
            const newWindow =
                this.addFixedBottomPannel(bottomPanelDivider, cloneDeep(el[0]));
            this.jsonObject.dividers.push(bottomPanelDivider);
            this.sashes.push(cloneDeep(newWindow));
        });
    }

    updateSashDisplacement() {
        const topLightFields = this.windowDimensionsService.topLightFields;
        const standardFields = this.windowDimensionsService.standardFields;
        const sashesHorizontally = topLightFields || standardFields;

        forEach(this.getInitialSashes(), (el, index) => {
            let x = index % sashesHorizontally;
            let y = Math.floor(index / sashesHorizontally);
            let width = 0;
            if (x === 0 && index > topLightFields) {
                x = (index - topLightFields) % standardFields;
            }
            if (index >= topLightFields) {
                for (let i = topLightFields; i < index; ++i) {
                    width += this.windowDimensionsService.getSashWidth(i);
                }
            } else {
                for (let i = 0; i < x; i++) {
                    width += this.windowDimensionsService.getSashWidth(i);
                }
            }
            if (y > 1) {
                y = 1;
            }
            const sash = find(this.getSashesJson(), el1 => el1.id === el.id);
            if (sash) {
                sash.x = width;
                if (this.windowDimensionsService.topLightFields === 0) {
                    sash.y = 0;
                } else if (index > this.windowDimensionsService.topLightFields - 1) {
                    sash.y = this.windowDimensionsService.getSashHeight(0);
                } else {
                    sash.y = 0;
                }
            }
        });
    }

    setMullionSetup(setup) {
        this.windowDimensionsService.blockMullions = false;
        this.setup = setup;
        const lastHeight = this.windowDimensionsService.height - setup.api_configuration.height;
        const sashPattern = find(setup.api_configuration.sashes, el1 =>
            el1.type.type !== 'F');

        forEach(this.sashes, (el) => {
            const currentSash = el;
            if (sashPattern.intSashes[0].muntins.horizontal) {
                forEach(el.muntins.horizontal, (el1, i) => {
                    el1.positionInSash = sashPattern.intSashes[0].muntins.horizontal[i].positionInSash;
                });
            }

            forEach(currentSash.intSashes, (el1, i) => {
                const currentIntSash = el1;
                const intSashPattern = sashPattern.intSashes[i];

                if (intSashPattern) {
                    currentIntSash.y = intSashPattern.y;
                    currentIntSash.height = intSashPattern.height;
                    if (!(setup.configuration.attributes.grill && ['1', '2'].indexOf(setup.configuration.attributes.grill.id > -1)) && 4) {
                        currentIntSash.muntins.horizontal = cloneDeep(intSashPattern.muntins.horizontal);
                    }

                    if (currentIntSash.nearDividers.bottom === -1 && lastHeight > 0) {
                        currentIntSash.height += lastHeight;
                    }
                }
            });
            const horizontals = filter(currentSash.intDividers, el1 =>
                el1.direction === 'horizontal');
            forEach(horizontals, (el1, i) => {
                if (el1.direction === 'horizontal') {
                    const currentIntDiv = el1;
                    const intDivPattern = sashPattern.intDividers[i];

                    currentIntDiv.position = intDivPattern.position;
                }
            });
        });

        forEach(this.fixedSashesGroups, (el) => {
            const currentSash = el;

            forEach(currentSash, (el1, i) => {
                const currentIntSash = el1;
                const intSashPattern = sashPattern.intSashes[i];

                if (intSashPattern) {
                    currentIntSash.y = intSashPattern.y;
                    currentIntSash.height = intSashPattern.height;
                    if (!(setup.configuration.attributes.grill && ['1', '2'].indexOf(setup.configuration.attributes.grill.id) > -1) && currentIntSash.muntins.horizontal) {
                        currentIntSash.muntins.horizontal = cloneDeep(intSashPattern.muntins.horizontal);
                    }

                    if (currentIntSash.nearDividers.bottom === -1 && lastHeight > 0) {
                        currentIntSash.height += lastHeight;
                    }
                    if (currentIntSash.nearDividers.top !== -1) {
                        const divider = this.dividersService.getDivider(currentIntSash.nearDividers.top);
                        divider.position = currentIntSash.y;
                    }
                }
            });
        });

        if (setup.configuration.attributes.grill && ['1', '2'].indexOf(setup.configuration.attributes.grill.id) === -1) {
            this.windowDimensionsService.blockMullions = true;
            this.windowDimensionsService.grill = setup.configuration.attributes.grill.id;
            this.updateGlazingBar(
                setup.configuration.attributes.height / 2,
                setup.configuration.attributes.height,
                setup.configuration.attributes.grill.id
            );
            this.offsetMuntins();


            forEach(this.sashes, (el) => {
                const currentSash = el;
                forEach(currentSash.intSashes, (el1) => {
                    const currentIntSash = el1;

                    if (currentIntSash.nearDividers.bottom === -1 && lastHeight > 0) {
                        currentIntSash.height += lastHeight;
                    }
                });
                forEach(currentSash.intDividers, (el1) => {
                    const currentIntDiv = el1;

                    if (currentIntDiv.direction === 'vertical' &&
                        currentIntDiv.length === setup.configuration.attributes.height &&
                        lastHeight > 0
                    ) {
                        currentIntDiv.height += lastHeight;
                    }
                });
            });

            forEach(this.fixedSashesGroups, (el) => {
                const currentSash = el;
                forEach(currentSash, (el1) => {
                    const currentIntSash = el1;
                    if (currentIntSash.nearDividers.bottom === -1 && lastHeight > 0) {
                        currentIntSash.height += lastHeight;
                    }
                });
            });
        } else if (setup.configuration.attributes.grill && ['1', '2'].indexOf(setup.configuration.attributes.grill.id) > -1) {
            let horizontals = [];
            if (sashPattern.intSashes[0].muntins.horizontal) {
                horizontals = sashPattern.intSashes[0].muntins.horizontal
                    .map(el => ({...el, end: { y: el.positionInSash } }));
            } else {
                horizontals = sashPattern.intSashes[0].muntins.filter((el) => {
                    if (el.end.x !== el.start.x) {
                        return el;
                    }
                    return null;
                });
            }

            forEach(this.sashes, (el) => {
                forEach(el.muntins.horizontal, (el1, i) => {
                    el1.positionInSash = horizontals[i].end.y;
                });

                forEach(el.intSashes, (el1) => {
                    forEach(el1.muntins.horizontal, (el2, i) => {
                        el2.positionInSash = horizontals[i].end.y;
                    });
                });
            });
        }
    }

    clearWindowOptions() {
        const systemDividers = this.$injector.get('addMullionService').systemAddedDividers;

        this.dividersHor = systemDividers.horizontal;
        this.dividersVert = systemDividers.vertical;
        this.mullionsHor = 0;
        this.mullionsVert = 0;

        this.resetSashes();
        this.updateSashesDimensions();
    }

    mirrorReflection() {
        const sashTypes = [];
        const intSashes = [];
        const dataService = this.$injector.get('dataService');

        if (!dataService.apiService.editSource) {
            this.clearWindowOptions();
        } else {
            this.resetSashes();
            this.updateSashesDimensions();
        }
        forEach(this.sashes, (el) => {
            const type = {...el.type };

            if (type.handlePosition) {
                type.handlePosition = type.handlePosition === 'L' ? 'R' : 'L';
            }

            intSashes.push(cloneDeep(el.intSashes));
            sashTypes.push(type);
        });

        forEach(sashTypes, (el, index) => {
            const i = this.sashes.length - index;

            this.sashes[i - 1].intSashes = intSashes[index];
            this.sashes[i - 1].type = {...el };
        });

        this.initialSashData = cloneDeep(this.sashes);
    }

    updateGlazingBar(heightAttr, bottomAttr, grillAtrr) {
        const value = isUndefined(grillAtrr) ? this.windowDimensionsService.grill : grillAtrr;

        if (value) {
            const glazingBars = this.jsonBuilderService.getInitialOptions('glazingBar');
            const currentGlazingBar = find(glazingBars, el => el.id === value);
            let width;
            let height;
            const bottomPannel = isUndefined(bottomAttr) ? this.windowDimensionsService.getBottomPannel() : bottomAttr;
            forEach(this.sashes, (el) => {
                width = cloneDeep(el.width);
                height = isUndefined(heightAttr) ? cloneDeep(el.height) : heightAttr;
                forEach(el.intSashes, (el1, index) => {
                    if (index < currentGlazingBar.data.sash.intSashes.length) {
                        el1 = Object.assign(el1, cloneDeep(currentGlazingBar.data.sash.intSashes[index]));
                        el1.id = index;
                        el1.parentId = el.id;
                        el1.width *= width;
                        el1.height *= bottomPannel;
                        el1.x *= width;
                        el1.y *= bottomPannel;

                        forEach(el1.muntins, (el2) => {
                            const currentMuntin = el2;
                            currentMuntin.start.x *= width;
                            currentMuntin.start.y *= bottomPannel;
                            currentMuntin.end.x *= width;
                            currentMuntin.end.y *= bottomPannel;
                        });
                    }
                });

                forEach(el.intDividers, (el1, index) => {
                    if (index < currentGlazingBar.data.sash.intDividers.length) {
                        el1 = Object.assign(el1, cloneDeep(currentGlazingBar.data.sash.intDividers[index]));
                        if (el1.direction === 'horizontal') {
                            el1.length *= width;
                            el1.position *= bottomPannel;
                        } else {
                            el1.length *= bottomPannel;
                            el1.position *= width;
                        }
                    }
                });
            });

            if (['1', '2', '3', '4', '7'].indexOf(currentGlazingBar.id) < 0) {
                forEach(this.fixedSashesGroups, (el) => {
                    forEach(el, (el1, index) => {
                        el1.width = width * 2 *
                            cloneDeep(currentGlazingBar.data.sash.intSashes[index].width);
                        el1.height = height * 2 *
                            cloneDeep(currentGlazingBar.data.sash.intSashes[index].height);
                        el1.y = height * 2 * cloneDeep(currentGlazingBar.data.sash.intSashes[index].y);
                        if (el1.nearDividers.top !== -1) {
                            const divider = this.dividersService.getDivider(el1.nearDividers.top);
                            divider.position = height * 2 *
                                cloneDeep(currentGlazingBar.data.sash.intSashes[index].y);
                        }
                        el1.muntins = cloneDeep(currentGlazingBar.data.sash.intSashes[index].muntins);
                        forEach(el1.muntins, (el2) => {
                            const currentMuntin = el2;
                            currentMuntin.start.x *= width * 2;
                            currentMuntin.start.y *= height * 2;
                            currentMuntin.end.x *= width * 2;
                            currentMuntin.end.y *= height * 2;
                        });
                    });
                });
            }
        }
    }

    offsetMuntins(sash = null, int = false) {
        if (!sash) {
            this.sashes.forEach((el1) => {
                this.offsetMuntins(el1, false);

                el1.intSashes.forEach((el2) => {
                    this.offsetMuntins(el2, true);
                });
            });
        } else if (sash.muntins && sash.muntins.length) {
            const usedProfiles = this.jsonBuilderService.getInitialAttributes('usedProfiles');

            const dividerProfile = usedProfiles.find(o => o.type === 'divider') || {};
            const frameProfile = usedProfiles.find(o => o.type === 'frame') || {};
            const sashProfile = usedProfiles.find(o => o.type === 'sash') || {};

            const dividerOffset = dividerProfile.spaceGlass || 25;
            const frameOffset = frameProfile.spaceGlass || 50;
            const sashOffset = frameProfile.spaceSash + sashProfile.spaceGlass || 100;
            let offset = 0;

            if (int) {
                offset = sashOffset;
            } else {
                offset = frameOffset;
            }

            const glazingOffset = {
                top: sash.nearDividers.top !== -1 ? dividerOffset : offset,
                left: sash.nearDividers.left !== -1 ? dividerOffset : offset,
                right: sash.nearDividers.right !== -1 ? dividerOffset : offset,
                bottom: sash.nearDividers.bottom !== -1 ? dividerOffset : offset,
            };

            const glazingRect = {
                x: glazingOffset.left,
                y: glazingOffset.top,
                width: sash.width - glazingOffset.left - glazingOffset.right,
                height: sash.height - glazingOffset.top - glazingOffset.bottom,
            };

            sash.muntins.forEach((muntin) => {
                if (muntin.start && muntin.end) {
                    muntin.start.x = glazingRect.x + ((glazingRect.width * muntin.start.x) / sash.width);
                    muntin.start.y = glazingRect.y + ((glazingRect.height * muntin.start.y) / sash.height);
                    muntin.end.x = glazingRect.x + ((glazingRect.width * muntin.end.x) / sash.width);
                    muntin.end.y = glazingRect.y + ((glazingRect.height * muntin.end.y) / sash.height);
                }
            });
        }
    }

    validateDividers(jsonObject) {
        forEach(jsonObject.dividers, (el) => {
            const currentDivider = el;

            if (currentDivider.direction === 'vertical') {
                currentDivider.adjacentDividers = {
                    left: [],
                    right: []
                };
            } else {
                currentDivider.adjacentDividers = {
                    top: [],
                    bottom: []
                };
            }
        });
    }

    validateSashesJson(jsonObject) {
        forEach(jsonObject.sashes, (el) => {
            const currentSash = el;
            Object.assign(currentSash, cloneDeep(this.config.jsonConfig.defaultSash));

            if (currentSash.type.id !== this.config.sashTypes.F) {
                currentSash.intSashes.push(Object.assign(
                    cloneDeep(this.config.jsonConfig.defaultIntSash), { parentId: currentSash.id }));
            }
        });
    }

    /**
     * Rebuild fixed sashes groups array
     */
    rebuildFixedSashesGroups() {
        const fixedSashes = this.getFixedSashes();
        this.fixedSashesGroups = [];
        if (fixedSashes.length) {
            forEach(fixedSashes, (el) => {
                this.fixedSashesGroups.push([el]);
            });
        }
    }

    hasMuntins() {
        return !!(this.mullionsHor + this.mullionsVert);
    }

    hasDividers() {
        return !!(this.dividersHor + this.dividersVert);
    }

}

SashesService.$inject = [
    'config',
    'dividersService',
    'windowDimensionsService',
    'internalSashesService',
    'mullionsService',
    'fixedSashesService',
    'jsonBuilderService',
    '$injector',
    '$rootScope',
];

export default angular.module('sashesService', [])
    .service('sashesService', SashesService)
    .name;